'use client';

import { ModeToggle } from '@/components/mode-toggle';
import type { CatalogThemeMode } from '@/components/catalog-theme-forcer';

import type { buttonVariants } from '@/components/ui/button';
import type { VariantProps } from 'class-variance-authority';

type CatalogThemeToggleProps = {
  mode: CatalogThemeMode;
  variant?: VariantProps<typeof buttonVariants>['variant'];
  className?: string;
};

export function CatalogThemeToggle({ mode, variant = 'ghost', className }: CatalogThemeToggleProps) {
  if (mode !== 'user') {
    return null;
  }
  return <ModeToggle variant={variant} className={className} />;
}
